export default __webpack_public_path__ + "static/media/no.d7bfaac1.svg";